import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { greyScaleColors } from '../../Globals/styles';
import ActivityTableItem from './activityTableItem';
import Waves from 'node-waves'
import { Scrollbars } from 'react-custom-scrollbars';

class ActivityTable extends Component{
  constructor(props) {
    super(props);
    this.state = {
      isQuickCreateActive: false
    }
  }
  toggleQuickCreate = () => {
    var isQuickCreateActive = this.state.isQuickCreateActive;
    this.setState({
      isQuickCreateActive: !isQuickCreateActive
    });
  };
  componentDidMount = () => {
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  addNewActivity = () => {
    if (this.refs.addActivityInputField.value.replace(/^\s+|\s+$/g, "").length > 0){
      this.props.addNewActivity(this.refs.addActivityInputField.value, this.props.rootActivity.id)
      this.setState({
        isQuickCreateActive: false
      });
    }
  };
  render()  {
    const {rootActivity, subActivities, activities, onActivityChange, addNewActivity, renameActivities} = this.props;

    //create plain
    var items = rootActivity.sortedActivityIds.map(sActivity=>{
      //create subs
      var childActivities;
      var activity;
      if (sActivity.hasChildren){
        childActivities = subActivities[sActivity.id].activityIds.map(id=>{return activities[id]})
        activity = subActivities[sActivity.id]
      }
      else {
        activity = activities[sActivity.id]
      }

      return <ActivityTableItem
                {...activity}
                key={sActivity.id}
                haveBorder={false}
                onActivityChange={onActivityChange}
                hoursPool={rootActivity.pool}
                childItems={childActivities}
                hoursRegistered={rootActivity.registered}
                addNewActivity={addNewActivity}
                renameActivities={renameActivities}
              />
    });

    var finalItems = items;

    return (
      <div style={styles.outerContainer}>
        <div style={styles.tableHeadings}>
          <div style={styles.headingName} className="col-xs-6">{rootActivity.name}</div>
          <div className="col-xs-4 text-center">{rootActivity.registered}</div>
          <div className="col-xs-2 text-right" onClick={this.toggleQuickCreate} style={styles.quickCreateIconContainer}>
           {this.state.isQuickCreateActive ? <i onClick={this.addNewActivity} style={styles.floppyIcon} className="fa fa-floppy-o waves-icon"></i> : null}
            <i style={[this.state.isQuickCreateActive && styles.quickCreateIconActive, styles.fixWaves]} className="fa fa-plus waves-icon"></i>
          </div>
        </div>
        <Scrollbars style={{ width: '100%', height: '100%'}}>
          <div style={styles.activityTableContainer}>
              {this.state.isQuickCreateActive ? <div style={styles.addActivityRow}>
                            <input
                              ref="addActivityInputField"
                              style={styles.addActivityInputField}
                              className="col-xs-5"
                              placeholder="Tilføj aktivitet..."/>
                          </div> : null}
              {finalItems}
          </div>
        </Scrollbars>
      </div>
    );
  }
}

var styles = {
  outerContainer:{
    height:'100%',
    position: 'relative',
    paddingTop: '42px'
  },
  container: {
    height: '100%'
  },
  activityTableContainer: {
    height: '100%',
    borderTop: '1px solid',
    borderColor: greyScaleColors.greyLighter
  },
  subActivity: {
    height: '40px',
    borderTop: '1px solid'
  },
  noBorder: {
    border: 'none'
  },
  tableHeadings: {
    width: '100%',
    position: "absolute",
    top:'0',
    fontSize: '18px',
    fontWeight: '600',
    height: '42px',
    lineHeight: '40px'
  },
  headingName: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    paddingLeft: '0'
  },
  addActivityRow: {
    width: '100%',
    height: '40px',
    borderBottom: '1px solid ' + greyScaleColors.greyLighter
  },
  addActivityInputField: {
    height: '39px',
    border: '0',
    paddingLeft: '6px',
    borderRadius: '2px'
  },
  quickCreateIconContainer: {
    cursor: 'pointer',
    position: 'relative'
  },
  quickCreateIconActive: {
    transform: 'rotate(45deg)'
  },
  floppyIcon: {
    position: 'absolute',
    top: '6px',
    left: '10px',
    fontSize: '20px',
    height: '30px',
    width: '30px',
    lineHeight: '30px'
  },
  fixWaves: {
    height: '30px',
    width: '30px',
    lineHeight: '30px'
  }
}

  ActivityTable.propTypes = {
    rootActivity: PropTypes.object.isRequired,
    subActivities: PropTypes.object.isRequired,
    activities: PropTypes.object.isRequired,
    addNewActivity: PropTypes.func.isRequired,
    renameActivities: PropTypes.func.isRequired
  };
export default Radium(ActivityTable);


// WEBPACK FOOTER //
// ./src/App/Project/RegisterActivities/activityTable.jsx